import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../../components/FormElements/Input";
import Radio from "../../../components/FormElements/Radio";

const EpisodeForm = ({
  isActive,
  episodeToRender,
  errors,
  activeEpisode,
  setValue,
  setModalOpen,
}) => {
  const setNowDate = () => {
    const currentDate = moment(new Date()).format("YYYY-MM-DD");
    const currentTime = moment(new Date()).format("HH:mm");

    setValue(`episodes.${activeEpisode}.release_date`, currentDate, {
      shouldValidate: true,
    });

    setValue(`episodes.${activeEpisode}.release_time`, currentTime, {
      shouldValidate: true,
    });
  };

  const { t } = useTranslation();

  return (
    <div
      className={`col-12 col-md-4 pt-4 px-4 col-bg-light-grey col-scrollable ${
        isActive ? "" : "d-none d-md-block"
      }`}
      id="sec-new"
    >
      <div className="d-flex justify-content-between align-items-center">
        <h2>{t("episodeForm.mainTitle")}</h2>
        {activeEpisode !== null && (
          <button
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="link-button"
          >
            <span onClick={() => setModalOpen(true)}>
              <i className="bi bi-eye"></i> {t("episodeForm.previewLink")}
            </span>
          </button>
        )}
      </div>
      {activeEpisode !== null ? (
        <fieldset className={`mb-2`}>
          <Input
            label={t("episodeForm.titleLabel")}
            id={`episodes.${activeEpisode}.title`}
            name={`episodes.${activeEpisode}.title`}
            placeholder=""
            marginBottom="sm"
            error={errors?.episodes?.[activeEpisode]?.title?.message}
            defaultValue={episodeToRender?.title}
          />
          <Input
            label={t("episodeForm.subtitleLabel")}
            id={`episodes.${activeEpisode}.subtitle`}
            name={`episodes.${activeEpisode}.subtitle`}
            placeholder=""
            marginBottom="sm"
            error={errors?.episodes?.[activeEpisode]?.subtitle?.message}
            defaultValue={episodeToRender?.subtitle}
          />
          <Input
            label={t("episodeForm.descriptionLabel")}
            id={`episodes.${activeEpisode}.description`}
            name={`episodes.${activeEpisode}.description`}
            placeholder=""
            marginBottom="md"
            text
            error={errors?.episodes?.[activeEpisode]?.description?.message}
            defaultValue={episodeToRender?.description}
            rows={10}
          />
          <div className="mb-4">
            <div className="row">
              <div className="col">
                <Input
                  label={t("episodeForm.releaseDateLabel")}
                  id={`episodes.${activeEpisode}.release_date`}
                  name={`episodes.${activeEpisode}.release_date`}
                  placeholder="MM/DD/YYYY"
                  marginBottom="sm"
                  type="date"
                  placeholderRightContent={
                    <a
                      href="#"
                      onClick={setNowDate}
                      className="ms-1"
                      id={`now-${activeEpisode}`}
                    >
                      {t("episodeForm.releaseDateNow")}
                    </a>
                  }
                  error={
                    errors?.episodes?.[activeEpisode]?.release_date?.message
                  }
                  defaultValue={episodeToRender?.release_date}
                  tip={t("episodeForm.releaseDateTip")}
                />
              </div>
              <div className="col">
                <Input
                  label={t("episodeForm.timeLabel")}
                  id={`episodes.${activeEpisode}.release_time`}
                  name={`episodes.${activeEpisode}.release_time`}
                  placeholder="HH:MM"
                  marginBottom="sm"
                  type="time"
                  error={
                    errors?.episodes?.[activeEpisode]?.release_time?.message
                  }
                  defaultValue={episodeToRender?.release_time}
                />
              </div>
            </div>
            <Input
              label={t("episodeForm.fileUrlLabel")}
              id={`episodes.${activeEpisode}.file_url`}
              name={`episodes.${activeEpisode}.file_url`}
              placeholder="https://hosting.net/audio.mp3"
              marginBottom="sm"
              error={errors?.episodes?.[activeEpisode]?.file_url?.message}
              defaultValue={episodeToRender?.file_url}
            />
            <Input
              label={t("episodeForm.fileSizeLabel")}
              id={`episodes.${activeEpisode}.video_length`}
              name={`episodes.${activeEpisode}.video_length`}
              placeholder="0"
              marginBottom="sm"
              error={errors?.episodes?.[activeEpisode]?.video_length?.message}
              defaultValue={episodeToRender?.video_length}
              onChange={(id, value) => {
                const inputElement = document.getElementById(id);
                if (inputElement) {
                  inputElement.value = value.replace(/[^0-9]/g, "");
                }
              }}
            />
          </div>
          <div className="mb-2">
            <label className="form-label">
              {t("episodeForm.durationLabel")}
            </label>
            <div className="row">
              <div className="col">
                <Input
                  label={t("episodeForm.hoursLabel")}
                  id={`episodes.${activeEpisode}.hours`}
                  name={`episodes.${activeEpisode}.hours`}
                  placeholder="00"
                  marginBottom="sm"
                  error={errors?.episodes?.[activeEpisode]?.hours?.message}
                  defaultValue={episodeToRender?.hours}
                />
              </div>
              <div className="col">
                <Input
                  label={t("episodeForm.minutesLabel")}
                  id={`episodes.${activeEpisode}.minutes`}
                  name={`episodes.${activeEpisode}.minutes`}
                  placeholder="00"
                  marginBottom="sm"
                  error={errors?.episodes?.[activeEpisode]?.minutes?.message}
                  defaultValue={episodeToRender?.minutes}
                />
              </div>
              <div className="col">
                <Input
                  label={t("episodeForm.secondsLabel")}
                  id={`episodes.${activeEpisode}.seconds`}
                  name={`episodes.${activeEpisode}.seconds`}
                  placeholder="00"
                  marginBottom="sm"
                  error={errors?.episodes?.[activeEpisode]?.seconds?.message}
                  defaultValue={episodeToRender?.seconds}
                />
              </div>
            </div>
          </div>
          <Radio
            label={t("episodeForm.ageRestrictionLabel")}
            name={`episodes.${activeEpisode}.age_restriction`}
            id={`episodes.${activeEpisode}.age_restriction`}
            options={[
              {
                id: `episodes.${activeEpisode}.age_restriction-false`,
                value: "false",
                label: t("episodeForm.ageRestrictionClean"),
                checked: false,
              },
              {
                id: `episodes.${activeEpisode}.age_restriction-true`,
                value: "true",
                label: t("episodeForm.ageRestrictionExplicit"),
                checked: false,
              },
            ]}
            error={errors?.episodes?.[activeEpisode]?.age_restriction?.message}
          />
        </fieldset>
      ) : (
        <p>{t("episodeForm.unselectedText")}</p>
      )}
    </div>
  );
};

export default EpisodeForm;
